import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { pick } from 'lodash';

import { HelpCreateTemplate } from '../../components/Templates/CreateGame/HelpCreateTemplate';
import { useSessionStore } from '../../stores/SessionStore';
import { useUserStore } from '../../stores/UserStore';

const HelpCreateScreen: React.FC = () => {
  const navigate = useNavigate();
  const userId = useSessionStore((state) => state.activeUserId);
  const { balance } = useUserStore((userState) => {
    const account = userState.getAccount(userId ?? '');
    return {
      ...pick(account, ['balance']),
    };
  });
  const remain = balance?.serviceToken ?? 0;

  // TODO: change navigate to the correct page
  const onClickicon1 = useCallback(() => {
    navigate('/home');
  }, [navigate]);
  const onClickicon2 = useCallback(() => {
    navigate('/home');
  }, [navigate]);
  const onClickicon3 = useCallback(() => {
    navigate('/home');
  }, [navigate]);
  const onClickicon4 = useCallback(() => {
    navigate('/home');
  }, [navigate]);

  return (
    <HelpCreateTemplate
      remain={remain}
      onClickicon1={onClickicon1}
      onClickicon2={onClickicon2}
      onClickicon3={onClickicon3}
      onClickicon4={onClickicon4}
    />
  );
};
export default HelpCreateScreen;
